// Modules
import React from 'react';
import PropTypes from 'prop-types';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import TimeReport from 'services/data/time-report';
import { LinkButton } from 'components/widgets/buttons/buttons';


// Component
export default class ArchivedTimeReportRow extends React.Component {
  static propTypes = {
    report: PropTypes.object.isRequired,
    afterSubmit: PropTypes.func,
    eagerUpdate: PropTypes.func,
    totalCols: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    this.unarchiveTimeReport = this.unarchiveTimeReport.bind(this);
  }

  unarchiveTimeReport() {
    const { report, afterSubmit, eagerUpdate } = this.props;
    const updates = { id: report.id, status: 'Active' };

    if (eagerUpdate) eagerUpdate(updates);

    TimeReport.update(updates)
      .then((response) => {
        if (afterSubmit) afterSubmit(response);
      })
      .catch(alerts.catchError);
  }

  render() {
    const { totalCols } = this.props;

    return (
      <tr className="archived-time-report">
        <td colSpan={totalCols}>
          Archived - <LinkButton onClick={this.unarchiveTimeReport}>Undo</LinkButton>
        </td>
      </tr>
    );
  }
}
